import { OrderViewType } from "@widgets/ecommerce/types/OrderViewType";
import { APPROVAL_DRAWER_SEGMENT } from "@features/orders-features/components/order-drawer/orderDrawerSegments";

/** Query params older links used to open a review, before the drawer had its own route. */
export const LEGACY_WEB_ORDER_ID_PARAMS = [
  "webOrderID",
  "webOrderId",
  "weborderId",
  "weborderID",
] as const;

const ORDERS_PAGE_PATH = "/orders/management";

export function parseWebOrderId(value: string | number | null | undefined) {
  const text = value == null ? "" : String(value);
  const id = Number(text);
  return /^[1-9]\d*$/.test(text) && Number.isSafeInteger(id) ? id : null;
}

/** Pathname that opens the review drawer for `webOrderId` over `pagePath`. */
export function getApprovalReviewPath(pagePath: string, webOrderId: number) {
  return `${pagePath.replace(/\/+$/, "")}/${APPROVAL_DRAWER_SEGMENT}/${webOrderId}`;
}

/**
 * In-app link to review an order approval on the Pending Approvals tab, without the site
 * prefix. Falls back to the tab alone when the id is missing.
 */
export function getApprovalReviewHref(webOrderId: number | null | undefined) {
  const id = parseWebOrderId(webOrderId);
  const pathname =
    id == null ? ORDERS_PAGE_PATH : getApprovalReviewPath(ORDERS_PAGE_PATH, id);
  return `${pathname}?tab=${OrderViewType.PendingApprovals}`;
}
